import { useTranslate } from 'react-polyglot';

import { useBreakpoint } from '@genially/design-system';

import { useHostClientContext } from '../../../host/application/pages/HostGamePage/components/HostClientProvider/hooks/useHostClientContext';
import { HostGameBreakdownSteps } from '../../../host/application/pages/HostGamePage/components/HostGame/HostGame.constants';
import { useNotificationManager } from '../services/useNotificationManager';
import { shareSessionCode } from '../utils/shareSessionCode';

export const useCopySessionLink = (from: 'game' | 'lobby') => {
  const t = useTranslate();

  const { isDownwards } = useBreakpoint();

  const isMobile = isDownwards(HostGameBreakdownSteps.forth);

  const { notificationManager } = useNotificationManager();

  const { client } = useHostClientContext();

  const { geniallyId, sessionId } = client;

  const handleCopySessionClick = async () => {
    shareSessionCode({
      geniallyId,
      sessionId,
      notificationManager,
      isMobile,
      t,
      from,
    });
  };

  return { handleCopySessionClick };
};
